<template>
  <div class="agila-info-block">
    <div class="agila-icon-info-circle" v-if="showInfoIcon"></div>
    <div><slot /></div>
  </div>
</template>

<script>
export default {
  props: {
    showInfoIcon: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.agila-info-block {
  display: inline-flex;
  align-items: center;
  border-left: 4px solid #004E9E;
  padding: 12px;
  color: #3C3C3C;
  background-color: #ffffff;

  .agila-icon-info-circle {
    background-image: url("data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_642_13066)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.05544 14.6518C5.37103 15.5308 6.91775 16 8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 6.41775 16.0308 4.87103 15.1518 3.55544C14.2727 2.23985 13.0233 1.21447 11.5615 0.608967C10.0997 0.00346624 8.49113 -0.15496 6.93928 0.153721C5.38743 0.462403 3.96197 1.22433 2.84315 2.34315C1.72433 3.46197 0.962403 4.88743 0.653721 6.43928C0.34504 7.99113 0.503466 9.59966 1.10897 11.0615C1.71447 12.5233 2.73985 13.7727 4.05544 14.6518ZM4.7962 2.45687C5.89253 1.72433 7.18146 1.33334 8.5 1.33334C10.2681 1.33334 11.9638 2.03572 13.214 3.28596C14.4643 4.5362 15.1667 6.23189 15.1667 8C15.1667 9.31854 14.7757 10.6075 14.0431 11.7038C13.3106 12.8001 12.2694 13.6546 11.0512 14.1592C9.83305 14.6638 8.49261 14.7958 7.1994 14.5386C5.90619 14.2813 4.71831 13.6464 3.78596 12.714C2.85361 11.7817 2.21867 10.5938 1.96143 9.3006C1.7042 8.0074 1.83622 6.66695 2.34081 5.44878C2.84539 4.23061 3.69987 3.18941 4.7962 2.45687ZM8.50002 5.55554C8.32393 5.55324 8.15569 5.48226 8.03116 5.35773C7.90664 5.2332 7.83566 5.06497 7.83336 4.88887V4.44443C7.83336 4.26762 7.90359 4.09805 8.02862 3.97302C8.15364 3.848 8.32321 3.77776 8.50002 3.77776C8.67683 3.77776 8.8464 3.848 8.97143 3.97302C9.09645 4.09805 9.16669 4.26762 9.16669 4.44443V4.88887C9.16439 5.06497 9.09341 5.2332 8.96888 5.35773C8.84435 5.48226 8.67612 5.55324 8.50002 5.55554ZM8.50002 12.2223C8.32393 12.2199 8.15569 12.149 8.03116 12.0244C7.90664 11.8999 7.83566 11.7317 7.83336 11.5556V7.11114C7.83336 6.93433 7.90359 6.76476 8.02862 6.63974C8.15364 6.51471 8.32321 6.44447 8.50002 6.44447C8.67683 6.44447 8.8464 6.51471 8.97143 6.63974C9.09645 6.76476 9.16669 6.93433 9.16669 7.11114V11.5556C9.16439 11.7317 9.09341 11.8999 8.96888 12.0244C8.84435 12.149 8.67612 12.2199 8.50002 12.2223Z' fill='%23004E9E'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_642_13066'%3E%3Crect width='16' height='16' fill='white' transform='translate(0.5)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    min-width: 17px;
    height: 16px;
    display: inline-flex;
    margin-right: 12px;
  }
}
</style>
